// const answerSetDoc = {
//   id: 'AS-29FJ39LSX3',
//   isStandard: true,
//   name: 'Answer Set',
//   type: 'likert',
//   choices: {
//     id1: { id: 'id1', value: 1, text: 'Strongly Disagree', p: '' },
//     id2: { id: 'id2', value: 2, text: 'Disagree', p: '' },
//     id3: { id: 'id3', value: 3, text: 'Neutral', p: '' },
//     id4: { id: 'id4', value: 4, text: 'Agree', p: '' },
//     id5: { id: 'id5', value: 5, text: 'Strongly Agree', p: '' },
//   },
//   includeNA: false,
//   naText: 'N/A',
// };

// prettier-ignore
const agreementAnswerSet = {
  guid: 'as-agreement',
  isStandard: true,
  isPublished: true,
  name: 'Agreement',
  type: 'likert',
  choices: {
    'c-agreement-1': { guid: 'c-agreement-1', value: '1', text: 'Strongly disagree', p: '0.125' },
    'c-agreement-2': { guid: 'c-agreement-2', value: '2', text: 'Disagree', p: '0.25' },
    'c-agreement-3': { guid: 'c-agreement-3', value: '3', text: 'Somewhat disagree', p: '0.375' },
    'c-agreement-4': { guid: 'c-agreement-4', value: '4', text: 'Neither agree nor disagree', p: '0.5', },
    'c-agreement-5': { guid: 'c-agreement-5', value: '5', text: 'Somewhat agree', p: '0.625' },
    'c-agreement-6': { guid: 'c-agreement-6', value: '6', text: 'Agree', p: '0.85' },
    'c-agreement-7': { guid: 'c-agreement-7', value: '7', text: 'Strongly agree', p: '0.875' },
  },
};

// prettier-ignore
const frequencyAnswerSet = {
  guid: 'as-frequency',
  isStandard: true,
  isPublished: true,
  name: 'Frequency',
  type: 'likert',
  choices: {
    'c-frequency-1': { guid: 'c-frequency-1', value: '1', text: 'Never', p: '0.167' },
    'c-frequency-2': { guid: 'c-frequency-2', value: '2', text: 'Rarely', p: '0.333' },
    'c-frequency-3': { guid: 'c-frequency-3', value: '3', text: 'Sometimes', p: '0.5' },
    'c-frequency-4': { guid: 'c-frequency-4', value: '4', text: 'Often', p: '0.667' },
    'c-frequency-5': { guid: 'c-frequency-5', value: '5', text: 'Always', p: '0.833' },
  },
};

const standardAnswerSets = [agreementAnswerSet, frequencyAnswerSet];

export default standardAnswerSets;
